<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12" class="pb-0">
        <MediaModeForm v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab')" :fields="mediaModeFields"
        :mediaMode="mediaMode" @mediaModeChange="mediaMode = $event"
        :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)"
        :mediaModeFlags="mediaModeFlags" @mediaModeFlagsChange="mediaModeFlags = $event" selectorMode showButtons
        @buttonClicked="onMediaFormButtonClicked($event)"></MediaModeForm>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <PlayerAvatarMedia v-if="mediaMode" :width="avatarSize.width" :height="avatarSize.height" :id="`analysis-${player.id}`"
          :title="mediaModeData.upperText" :subtitle="mediaModeData.lowerText"
          :color="mediaModeData.borderColor" ref="playerAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :player="player"
          :face="mediaModeData.face.dataUrl"
          :nationalTeam="mediaModeData.nationalTeam"
          type="analysis"
          :lineDistance="mediaModeData.lineLength"
          :avatarSize="mediaModeData.avatarSize"
          :lineWeight="mediaModeData.lineWeight"
          :upperTextFontSize="mediaModeData.upperTextFontSize" :upperTextFontWeight="mediaModeData.upperTextFontWeight"
          :lowerTextFontSize="mediaModeData.lowerTextFontSize" :lowerTextFontWeight="mediaModeData.lowerTextFontWeight"
          class=""></PlayerAvatarMedia>
      </v-col>
    </v-row>
    <v-row v-if="mediaMode">
      <v-col cols="6" class="py-0" v-for="side of 2" :key="`header-text-${side}`" v-bind:class="{'pr-0 pl-4': side === 1,'pl-0 pr-4': side === 2}" >
        <DriblabSVGText :text="mediaModeData[`headerText${side}`]" :width="null" :height="mediaModeData.chartHeaderFontSize ? mediaModeData.chartHeaderFontSize * 2.5 : 50" class="w-100"
          :id="`header-${side}`" justify="middle" v-if="mediaModeData[`headerText${side}`]"
          :fontSize="mediaModeData.chartHeaderFontSize" :weight="mediaModeData.chartHeaderFontWeight"
          ref="headerTextRef"
        ></DriblabSVGText>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" v-for="side of 2" :key="side" v-bind:class="{'pr-1': side === 1,'pl-1': side === 2}" class="pt-0">
        <PlayerFinishingMap :playerId="player.id" :headerPlayer="player" :chartId="Number(`1${side}`)" class="" stackedView v-if="mediaModeData[`chart${side}`] === 'finishingMap'" ref="finishingMapRef"></PlayerFinishingMap>
        <PlayerKeyPassMap :playerId="player.id" :chartId="Number(`2${side}`)" class="" stackedView v-if="mediaModeData[`chart${side}`] === 'keyPassMap'" ref="keyPassMapRef"></PlayerKeyPassMap>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatDate } from "../../utils/functions";
import PlayerFinishingMap from './PlayerFinishingMap';
import PlayerKeyPassMap from './PlayerKeyPassMap';
import PlayerAvatarMedia from './PlayerAvatarMedia';
import MediaModeForm from '../base/MediaModeForm';
import {downloadPng,exportSvg,copyAndAppendElement,generateSocialMediaSVG} from "../../utils/exportToPNG";
import DriblabSVGText from '../base/DriblabSVGText';

export default {
  name: "PlayerAnalysis",
  components:{
    PlayerKeyPassMap,
    PlayerFinishingMap,
    PlayerAvatarMedia,
    DriblabSVGText,
    MediaModeForm
  },
  filters: {
    formatDate(date, language) {
      return formatDate(date, language);
    }
  },
  props:{
    player:{
      type: Object,
      required: true
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    avatarSize(){
      let accumWidth = 0
      if(this.$refs.finishingMapRef && this.$refs.finishingMapRef.length){
        _.forEach(this.$refs.finishingMapRef,(r) => {
          let dims = r.$el.getBoundingClientRect();
          accumWidth += dims.width;
        })
      }else if(this.$refs.finishingMapRef && !this.$refs.finishingMapRef.length){
        let dims = this.$refs.finishingMapRef.$el.getBoundingClientRect();
        accumWidth += dims.width;
      }
      if(this.$refs.keyPassMapRef && this.$refs.keyPassMapRef.length){
        _.forEach(this.$refs.keyPassMapRef,(r) => {
          let dims = r.$el.getBoundingClientRect();
          accumWidth += dims.width;
        })
      }else if(this.$refs.keyPassMapRef && !this.$refs.keyPassMapRef.length){
        let dims = this.$refs.keyPassMapRef.$el.getBoundingClientRect();
        accumWidth += dims.width;
      }
      return {
        width: accumWidth,
        height: accumWidth / 7.5
      }
    }
  },
  data() {
    return {
      mediaMode: false,
      mediaModeFields: [
        {type:"text",label:"mediaMode.upperText",key:"upperText"},
        {type:"number",label:"mediaMode.upperTextFontSize",key:"upperTextFontSize"},
        {type:"radio",label:"mediaMode.upperTextFontWeight",key:"upperTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.lowerText",key:"lowerText"},
        {type:"number",label:"mediaMode.lowerTextFontSize",key:"lowerTextFontSize"},
        {type:"radio",label:"mediaMode.lowerTextFontWeight",key:"lowerTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"radio",label:"mediaMode.chartX",key:"chart1",general:true,labelParams:[1],options:[{value:"finishingMap",label:"playerDetail.finishingMap"},{value:"keyPassMap",label:"playerDetail.keyPassMap"}]},
        {type:"radio",label:"mediaMode.chartX",key:"chart2",general:true,labelParams:[2],options:[{value:"finishingMap",label:"playerDetail.finishingMap"},{value:"keyPassMap",label:"playerDetail.keyPassMap"}]},
        {type:"text",label:"mediaMode.headerTextX",key:"headerText1",general:true,labelParams:[1]},
        {type:"text",label:"mediaMode.headerTextX",key:"headerText2",general:true ,labelParams:[2]},
        {type:"number",label:"mediaMode.chartHeaderFontSize",key:"chartHeaderFontSize",general:true},
        {type:"radio",label:"mediaMode.chartHeaderFontWeight",key:"chartHeaderFontWeight",general:true
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"color",label:"mediaMode.textColor",key:"textColor",general:true},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor",general:true},
        {type:"color",label:"mediaMode.borderColor",key:"borderColor",general:true},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",general:true,force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",general:true,force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",general:true,force:true},
        {type:"image",label:"mediaMode.face",key:"face",general:true},
        {type:"switch",label:"mediaMode.nationalTeam",key:"nationalTeam"},
      ],
      mediaModeFlags: {bgColor:null,textColor: null, nationalTeam: null},
      mediaModeData: {bgColor:"#ffffff",textColor:"#000000",borderColor:"#3366FF",face:{},chart1:"finishingMap",chart2:"keyPassMap",upperTextFontWeight:"900",lowerTextFontWeight:"400"},
    };
  },
  watch:{
    'mediaModeData.chart1': function(newValue,oldValue){
        this.mediaModeData.headerText1 = this.$t(`playerDetail.${newValue}`);
    },
    'mediaModeData.chart2': function(newValue,oldValue){
        this.mediaModeData.headerText2 = this.$t(`playerDetail.${newValue}`);
    }
  },
  mounted() {
    this.mediaMode = this.currentUser.mediaMode || this.currentUser.clientType === 'Media';
    this.mediaModeData.upperText = this.player.name;
    this.mediaModeData.lowerText = this.$t("playerDetail.analysis");
    this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.id}.png`;
    this.mediaModeData[`headerText1`] = this.$t(`playerDetail.finishingMap`);
    this.mediaModeData[`headerText2`] = this.$t(`playerDetail.keyPassMap`);
  },
  created() {},
  methods: {
    onChartChange(event,side){
      this.mediaModeData[`headerText${side}`] = this.$t(`playerDetail.${event}`);
      this.onMediaModeDataChange(this.mediaModeData);
    },
    onMediaModeDataChange(event){
      this.mediaModeData = {...event};
      setTimeout(() => {
        if(this.$refs.playerAvatarMediaRef){
          this.$refs.playerAvatarMediaRef.printD3(this.mediaModeData.force);
        }
        if(this.$refs.headerTextRef){
          _.forEach(this.$refs.headerTextRef,(r) => {r.printD3()});
        }
      },10)
    },
    onMediaFormButtonClicked(event){
      if(event === "SVG"){
        this.saveAsSVG();
      }else if(event === "PNG"){
        this.saveAsPNG();
      }
    },
    async saveAsPNG() {
      let  svg = await this.prepareSvgForMedia();
      downloadPng(svg, `Driblab_Analysis_${this.player.name.replace(' ','_')}.png`);
    },
    async saveAsSVG() {
      let  svg = await this.prepareSvgForMedia();
      exportSvg( svg, `Driblab_Analysis_${this.player.name.replace(' ','_')}`);
    },
    async prepareSvgForMedia(){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      let widthAccum = 50;
      let yOffset = 120;
      let out = parent.appendChild(document.createElement("defs"))
                    .appendChild(document.createElement("style"))
      out.setAttribute('type', 'text/css')
      parent.style.background = this.mediaModeData.bgColor;

      let avatarEl = document.querySelector(`#playerAvatarMediaanalysis-${this.player.id}SVG`);
      let avatarDims = avatarEl.getBoundingClientRect();
      copyAndAppendElement(parent,avatarEl,widthAccum,0)

      //JOin charts
      _.forEach([1,2],(s,index) => {
        let side = this.mediaModeData[`chart${s}`]
        let target = side === 'finishingMap' ? "pitchXG" : "pitchXA"

        let headerEl = document.querySelector(`#driblabSVGTextheader-${index+1}SVG`);
        let headerDims = headerEl.getBoundingClientRect();
        copyAndAppendElement(parent,headerEl,widthAccum,avatarDims.height)

        let chartEl = document.querySelector(`#${target}${this.player.id}-${index+1}${side === 'finishingMap' ? 1 : 2}SVG`);
        let chartDims = chartEl.getBoundingClientRect();
        copyAndAppendElement(parent,chartEl,widthAccum,avatarDims.height + headerDims.height)

        heightAccum = chartDims.height += (avatarDims.height + headerDims.height);
        widthAccum += chartDims.width + 50;
      });

      let socialMediaSVG = await generateSocialMediaSVG(widthAccum,this.mediaModeData.textColor,this.mediaModeData.bgColor);
      copyAndAppendElement(parent,socialMediaSVG.node(),50,heightAccum)

      parent.setAttribute("width",widthAccum);
      parent.setAttribute("height",heightAccum + 50);
      return parent;
    },
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/player/PlayerAnalysis.vue